import { HTMLAttributes } from 'react';
import styled from 'styled-components';

import { color } from 'theme/selectors';

export const ModalContainer = styled.div<HTMLAttributes<HTMLDivElement>>`
    position: relative;
    padding: 32px 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 432px;
    margin: 0 auto;
`;

export const SubscriptionAdditionalInfo = styled.div<HTMLAttributes<HTMLDivElement>>`
    margin: 0 0 24px 0;
    background: ${color('surface-secondary')};
    padding: 8px 12px;
    border-radius: 8px;
`;
